/* Maps SDG codes (used in the backend / DB) to short, human-readable
 * impact labels shown to founders and funders on the landing page,
 * dashboards, funder terminal, etc.
 *
 * Keep the labels 1–3 words and outcome-focused.
 * The underlying data values ("SDG 2", "SDG 7" …) are unchanged.
 */
export const SDG_LABELS = {
  "SDG 2":  "Food Security",
  "SDG 3":  "Health Access",
  "SDG 4":  "Education",
  "SDG 5":  "Gender-lens",
  "SDG 7":  "Clean Energy",
  "SDG 8":  "Decent Work",
  "SDG 9":  "Infrastructure",
  "SDG 12": "Sustainable Production",
  "SDG 13": "Climate Action",
};

export const sdgLabel = (code) => SDG_LABELS[code] || code || "";

/* Convenience: a list of {value, label} for chip pickers + admin forms. */
export const SDG_OPTIONS = Object.entries(SDG_LABELS).map(([value, label]) => ({
  value, label,
}));

/* Convenience: comma-joined label list (handles empty + the "—" fallback). */
export const sdgListLabels = (codes) => {
  if (!Array.isArray(codes) || codes.length === 0) return "—";
  return codes.map(sdgLabel).join(", ");
};
